import React from 'react';
import './FeedbackModal.css';

function FeedbackModal({ isOpen, onClose, message, type = 'success' }) {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return '✅';
      case 'warning':
        return '⚠️';
      case 'error':
        return '❌';
      default:
        return '💡';
    }
  };

  return (
    <div className={`feedback-modal-overlay ${isOpen ? 'active' : ''}`} onClick={onClose}>
      <div className={`feedback-modal ${isOpen ? 'slide-up' : ''}`} onClick={(e) => e.stopPropagation()}>
        <div className="feedback-modal-icon">{getIcon()}</div>
        <div className="feedback-modal-message">{message}</div>
        <button className="feedback-modal-close" onClick={onClose}>
          OK
        </button>
      </div>
    </div>
  );
}

export default FeedbackModal;
